/**
 * Recursive utility function to traverse through the data to find the value corresponding to the sent key
 *
 * @param {Object} obj - data object to traverse through
 * @param {String} key - key value to find
 * @returns  - value found or null
 */
export function findKey(obj, key) {
  if (typeof obj !== 'object' || obj === null) {
    return null;
  }

  if (Object.prototype.hasOwnProperty.call(obj, key)) {
    return obj[key];
  }

  for (const k in obj) {
    const result = findKey(obj[k], key);
    if (result !== null) {
      return result;
    }
  }

  return null;
}
